import { render, staticRenderFns } from "./LegalAndCompliance.vue?vue&type=template&id=5b193a06&scoped=true&"
import script from "./LegalAndCompliance.vue?vue&type=script&lang=ts&"
export * from "./LegalAndCompliance.vue?vue&type=script&lang=ts&"
import style0 from "./LegalAndCompliance.vue?vue&type=style&index=0&id=5b193a06&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b193a06",
  null
  
)

export default component.exports